import { useState } from 'react';
import styles from '../css/MapUI.module.css';
//파일 import
import Header from './Header';
import Report from './report/Report';
import Search from './search/MainSearch';
import MultiSearch from './search/MultiSearch';
import Modal from './modal/Modal';
import ModalDetail from './modal/ModalDetail';
import { useTranslation } from "react-i18next";
// import i18n from 'i18next';
import BusinessSelect from './commercial/AnalysisSelecting';
import GuSelect from './commercial/AnalysisToggle';
// import ClusterChange from './bottomContents/RangeControl';
import Cluster from '../contents/bottomContents/ClusterList';
import RangeControl from '../contents/bottomContents/RangeControl';
import SearchControl from '../contents/bottomContents/SearchControl';
import ToggleBtn from '../contents/commercial/ToggleBtnWhite';

export default function MapUI({
  state,
  setState,
  modal,
  setModal,
  mapData,
  sliderValue,
  setSliderValue,
  handleSliderChange,
  handleColorChange,
  handleAreaSelect,
  itemData,
  // setShow,
  getRangeIndex,
  handleResetClick,
  setLoading,
  reportBusiness,
  setIsExpanded,
  setColor,
  currentBase,
  setCurrentBase,
  color,
  searchType,
  setSearchType,
  searchGubun,
  setSearcGubun,
  searchItem,
  setSearcItem,
  modalPolygonCenter,
  modalPolygonPath,
  selectedPolygon,
  // navermapData,
  modalPolygonArea,
  setAnalData,
  setAnalDetailData,
  analData,
  analDetailData,
  areaInfo,
  gradeTextData,
  setMarkerData,
  setClusterInfo,
  clusterInfo,
  handleReangeChange,
  rangeChangeData,
  setRangeChangeData,
  colorStyles,
  setRangeMin,
  setRangeMax,
  rangeMin,
  rangeMax,
  handleRangeChange,
  setSearchMin,
  setSearchMax,
  searchMin,
  searchMax,
  handleTabSelect,
  removeHeatMap,
  searchClusterByText,
  analViewData, 
  setAnalViewData,
  sectorData,
  analysisData,
  searchClusterByMul
}) {

  const [nullData, setNullData] = useState(null);

  //Select Detail select state
  const [checkedMenus, setCheckedMenus] = useState([]);
  const [checkedCodeMenus, setCheckedCodeMenus] = useState([]);

  //상권분석 업종선택
  const [checkedArray, setCheckedArray] = useState([]);

  const colorList = ['red', 'green', 'blue', 'purple', 'indigo', 'brown'];

  const { t } = useTranslation();

  const resetBtn = () => {
    setLoading(true) //loading ...
    setIsExpanded(false)
    setClusterInfo(false)
    //setColor('red') //지도 색상 초기화
    setSliderValue(0) //클러스터 변경 초기화
    setSearchMin(0);
    setSearchMax(1640);
    setSearchType('num')
    setCurrentBase('상점수')
    setNullData(null)

    setCheckedMenus([])
    setCheckedArray([])
    handleAreaSelect('', '') //gu reset
    handleResetClick() //map reset
    setAnalData([])
    setAnalDetailData([])
    setMarkerData([])
    removeHeatMap()

    setSearcGubun('')
    setSearcItem('')
    setRangeChangeData([]);
    setState({...state, containerShow: false, containerShow2: false, containerShow3: false});
  }

  const businessProps = {
    state,
    setState,
    modal,
    setModal,
    checkedArray,
    setCheckedArray,
    nullData,
    setNullData,
    setAnalData,
    setAnalDetailData,
    analData,
    checkedMenus,
    checkedCodeMenus,
    analViewData, 
    setAnalViewData,
    analysisData
  }

  const modalProps = {
    checkedMenus,
    setCheckedMenus,
    checkedCodeMenus,
    setCheckedCodeMenus,
    checkedArray,
    setCheckedArray,
    nullData,
    modal,
    setModal,
    state,
    setState,
    modalPolygonCenter,
    modalPolygonPath,
    reportBusiness,
    selectedPolygon,
    // navermapData,
    itemData,
    modalPolygonArea,
    areaInfo,
    setAnalDetailData
  }

  const delectCheckedArray = (item, code) => {
    const newCheckedArray = checkedArray.filter(menu => menu !== item);
    setCheckedArray(newCheckedArray);

    const newCodeArray = analData.filter(menu => menu !== code);
    setAnalData(newCodeArray);

    const newViewCodeArray = analViewData.filter(menu => menu.code !== code);
    setAnalViewData(newViewCodeArray);
  }

  const delectCheckedMenus = (item, code) => {
    const newCheckedMenus = checkedMenus.filter(menu => menu !== item);
    setCheckedMenus(newCheckedMenus);

    const newCodeArray = analDetailData.filter(menu => menu !== code);
    setAnalDetailData(newCodeArray);
  }

  const delectArea = () => {
    setState({ ...state, gu: '' })
    handleAreaSelect('', '') //gu reset
  }

  const delectGubun = () => {
    setSearcGubun('')
    setSearcItem('')
    setRangeChangeData([]);
  }

  const isMultiSearchClicked = () => {
		setState({...state, containerShow2: !state.containerShow2, containerShow: false, containerShow3: false})
	}

  const isSearchClicked = () => {
    setState({...state, containerShow3: !state.containerShow3, containerShow: false, containerShow2: false})
  }

  return (
    <>
      {/* Header */}
      <Header t={t} state={state} />

      {/* 결과보고서*/}
      {reportBusiness &&
        <Report state={state}
          setState={setState}
          itemData={itemData}
          setIsExpanded={setIsExpanded}
          reportBusiness={reportBusiness}
          handleTabSelect={handleTabSelect}
        />
      }
      <div className={`${styles.menu} ${state.toggle ? styles.menuMoved : styles.menuOrigin}`}>
        <button type='reset'
          className={styles.resetBtn}
          onClick={resetBtn}
          style={{ backgroundColor: "#fff" }}>
          <img src='img/icon_change.png' alt='reset' />
          초기화
        </button>
        <button type='button'
          className={state.search ? styles.fontBlue : styles.fontBlack}
          onClick={() => setState({ ...state, search: !state.search, toggle: false, toggleGu: false, menu: false, range: false })}>
          <img src={state.search ? 'img/icon_ruler_blue.png' : 'img/icon_ruler.png'} alt='base' />
          {/* {`기준: ${currentBase}`} */}
          범위
        </button>
        {
          state.search &&
          <SearchControl
            state={state}
            setState={setState}
            searchGubun={searchGubun}
            setSearcGubun={setSearcGubun}
            searchItem={searchItem}
            setSearcItem={setSearcItem}
            handleReangeChange={handleReangeChange}
          />
        }
        <button type='button'
          className={state.range ? styles.fontBlue : styles.fontBlack}
          onClick={() => setState({ ...state, range: !state.range, toggle: false, toggleGu: false, menu: false, search: false })}>
          <img src={state.range ? 'img/icon_setting_blue.png' : 'img/icon_setting.png'} alt='base' />
          {/* {`기준: ${currentBase}`} */}
          기준
        </button>
        {
          state.range &&
          <RangeControl
            state={state}
            setState={setState}
            setCurrentBase={setCurrentBase}
            searchType={searchType}
            setSearchType={setSearchType}
            setRangeMin={setRangeMin}
            setRangeMax={setRangeMax}
            rangeMin={rangeMin}
            rangeMax={rangeMax}
            handleRangeChange={handleRangeChange}
          />
        }
        <button type='button'
          className={state.toggleGu ? styles.fontBlue : styles.fontBlack}
          onClick={() => setState({ ...state, toggleGu: !state.toggleGu, toggle: false, menu: false, range: false, search: false })}>
          <img src={state.toggleGu ? 'img/icon_location_blue.png' : 'img/icon_location.png'} alt='location' />
          {/* {state.gu.length > 0 ? `위치: ${state.gu}` : '구역선택'} */}
          구역
        </button>
        {
          state.toggleGu &&
          <GuSelect state={state}
            setState={setState}
            handleAreaSelect={handleAreaSelect}
            sectorData={sectorData} 
          />
        }
        <button type='button'
          className={state.menu ? styles.fontBlue : styles.fontBlack}
          onClick={() => setState({ ...state, menu: !state.menu, toggle: false, toggleGu: false, range: false, search: false })}>
          <img src={state.menu ? 'img/icon_retail_blue.png' : 'img/icon_retail.png'} alt='retail' />
          상권분석
        </button>
        {
          state.menu &&
          <BusinessSelect {...businessProps} />
        }
      </div>

      {
        modal.modalSelect &&
        <Modal {...modalProps} />
      }
      {
        modal.modalPolygon &&
        <ModalDetail {...modalProps} />
      }
      
      {/* 검색어 입력 화면 */}
      {!clusterInfo &&
        <div style={{ position: 'absolute', top: '70px', width: '20%'}} className={`${state.containerShow ? styles.containerShow : styles.containerHide}`}>
          <Search 
              searchClusterByText={searchClusterByText}
              sectorData={sectorData}
              analysisData={analysisData}
          />
        </div>
      }
      {!clusterInfo &&
        <ToggleBtn state={state} setState={setState}/>
      }

      {/* 멀티선택 입력 화면 */}
      {!clusterInfo &&
        <div style={{ position: 'absolute', top: '108px', width: '20%'}} className={`${state.containerShow2 ? styles.containerShow : styles.containerHide}`}>
          <MultiSearch
              sectorData={sectorData}
              analysisData={analysisData}
              searchClusterByMul={searchClusterByMul}
          />
        </div>
      }
      {!clusterInfo &&
        <button type='button'  className={`${styles.toggleBtn2} ${state.containerShow2 ? styles.toggleBtnShow : styles.toggleBtnHide}`} onClick={isMultiSearchClicked}>
          멀티검색 <img src={state.containerShow2 ? 'img/icon_arrow_left.png' : 'img/icon_arrow_right.png'} alt='toggleBtn'/>
        </button>
      }

      {/* 선택 조건 화면 */}
      {!clusterInfo &&
        <div className={`${styles.topContent} ${state.containerShow3 ? styles.containerShow : styles.containerHide}`}>
          <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between'}}>
            <div className={styles.anal_list}>
              <div>
                {currentBase}
              </div>
            </div>
            <div className={styles.anal_list}>
              <div>
                {rangeMin} ~ {rangeMax}
              </div>
            </div>
            {(rangeChangeData.length > 0) > 0 &&
              <div className={styles.anal_list}>
                <div>
                  {searchGubun} {searchItem}
                </div>
                <button className={styles.closeBtn} onClick={delectGubun}><img src="img/icon_close.png" /></button>
              </div>
            }
            {state.gu.length > 0 &&
              <div className={styles.anal_list}>
                {state.gu}
                <button className={styles.closeBtn} onClick={delectArea}><img src="img/icon_close.png" /></button>
              </div>
            }
            {analViewData.map((item, idx) => (
              <div className={styles.anal_list} key={'anal_' + idx}>
                {item.name}
                <button className={styles.closeBtn} onClick={(e) => delectCheckedArray(item.name, item.code)}><img src="img/icon_close.png" /></button>
              </div>
            ))}
            {analDetailData.map((item, idx) => (
              <div className={styles.anal_list} key={'anal_detail_' + idx}>
                {checkedMenus[idx]}
                <button className={styles.closeBtn} onClick={(e) => delectCheckedMenus(checkedMenus[idx], item)}><img src="img/icon_close.png" /></button>
              </div>
            ))}
          </div>
        </div>
      }
      {!clusterInfo &&
        <button type='button'  className={`${styles.toggleBtn3} ${state.containerShow3 ? styles.toggleBtnShow : styles.toggleBtnHide}`} onClick={isSearchClicked}>
          선택조건 <img src={state.containerShow3 ? 'img/icon_arrow_left.png' : 'img/icon_arrow_right.png'} alt='toggleBtn'/>
        </button>
      }

      <div className={styles.bottomContent}>
        {
          state.cluster &&
          <Cluster color={color}
            currentBase={currentBase}
            setCurrentBase={setCurrentBase}
            searchType={searchType}
            setSearchType={setSearchType}
            state={state}
            setState={setState}
            handleColorChange={handleColorChange}
            mapData={mapData}
            sliderValue={sliderValue}
            handleSliderChange={handleSliderChange}
            getRangeIndex={getRangeIndex}
            colorList={colorList}
            gradeTextData={gradeTextData}
            colorStyles={colorStyles}
          />
        }
      </div>
    </>
  )
}


